import { memo } from 'react';

import { useAssetModalVersionsPanel } from '~/components/AssetModalV2/AssetModalPanelsContextProvider';
import { AssetModalLeftPanelCloseButton } from '~/components/AssetModalV2/Content/Panel/components/AssetModalLeftPanelCloseButton';

export const PublicVersionsPanelHeader = memo(() => {
  const { closeVersionsPanel } = useAssetModalVersionsPanel();

  return (
    <header
      className="flex h-14 shrink-0 items-center justify-between gap-2 px-4 pt-4 pb-2"
      data-testid="PUBLIC_VERSIONS_PANEL_HEADER"
    >
      <h2
        className="font-medium ads:text-primary text-14 text-gray-12"
        data-testid="PUBLIC_VERSIONS_PANEL_HEADER_TITLE"
      >
        Versions
      </h2>

      <AssetModalLeftPanelCloseButton
        data-testid="PUBLIC_VERSIONS_PANEL_HEADER_CLOSE_BUTTON"
        label="Close versions panel"
        size="medium"
        tooltipLabel="Close versions panel"
        onClick={closeVersionsPanel}
      />
    </header>
  );
});

PublicVersionsPanelHeader.displayName = 'PublicVersionsPanelHeader';
